

// cart page js start

$(document).on('click', '.custom_cart_liquid', function(){
    $(this).closest('.cart-item').find('.loading__spinner').removeClass('hidden');
    var mainPrdRemove = $(this).prev();
    
    var prdTitle    = $(this).closest('.cart-item').find('.cart-item__name').text().trim();
    var prdvarinat  = $(this).closest('.cart-item').find('.option_variant').text().trim();
    var sellingPlan = $(this).closest('.cart-item').find('.item_selling_plan').text().trim();

    var finalPrdTitle = (prdTitle + " " + prdvarinat + " " + sellingPlan).trim().replace(/\s+/g, ' ');

    //alert(finalPrdTitle);
    var itemsToRemove = [];

    // collect all item IDs
    $('.included_in').each(function(){
        var value = $(this).attr('value');
        var includeSellPlan = $(this).attr('sellingplan');
        includeSellPlan = includeSellPlan.replace('  ', ' ');
        var finalValue = (value + " " + includeSellPlan).trim().replace(/\s+/g, ' ');

        if(finalPrdTitle == finalValue){
            var varIncludedItemId = parseInt($(this).attr('item_prd_id'), 10);
            if(varIncludedItemId > 0){
                itemsToRemove.push(varIncludedItemId);
            }
        }
    });

    if(itemsToRemove.length > 0){
        // prepare quantities object for bulk update
        var updates = {};
        itemsToRemove.forEach(function(variantId){
            updates[variantId] = 0;  // set qty=0 to remove
        });

        $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: { updates: updates },
            dataType: 'json',
            success: function(cart) {
                $(mainPrdRemove).trigger('click');
                console.log("Removed items:", itemsToRemove);
                // optional: refresh cart UI
                // location.reload();
            }
        });
    } else {
        //alert("No items found to remove.");
        $(mainPrdRemove).trigger('click');
    }


    
});
setInterval(function(){
   var prdOption = $('.main_cart_item');
    $(prdOption).each(function(){
    var optionBundlePrd = $(this).find('dd[product_options="Bundles"]');
    console.log(optionBundlePrd.length);
    if(optionBundlePrd.length == 0){
        $(this).addClass('qty_clickable');
    }else {
        $(this).removeClass('qty_clickable');
    }
    });
},1000);


// cart page js end